export default __webpack_public_path__ + "static/BusinessInternet-41d84077baf30bc52332238669f34ad5.jpeg";